// extracted by mini-css-extract-plugin
module.exports = {"Panel":"UploadPanel_Panel__etbD_","IconWrapper":"UploadPanel_IconWrapper__Ffap7","Icon":"UploadPanel_Icon__PtKVQ","Guide":"UploadPanel_Guide__6xrfY"};